import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';

const SalesInvoiceForm = ({ receipt, customers, currentLocationId, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    nabywca_nazwa: '',
    nabywca_nip: '',
    nabywca_adres: '',
    nabywca_miasto: '',
    nabywca_kod_pocztowy: '',
    nabywca_telefon: '',
    nabywca_email: '',
    location_id: currentLocationId || 1,
    typ_faktury: 'imienna'
  });

  const [selectedCustomerId, setSelectedCustomerId] = useState('');
  const [customerSearchTerm, setCustomerSearchTerm] = useState('');
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);

  // Automatycznie wypelnij dane klienta z paragonu przy pierwszym zaladowaniu
  useEffect(() => {
    if (receipt && receipt.klient_id) {
      const customerName = receipt.nazwa_firmy || `${receipt.imie || ''} ${receipt.nazwisko || ''}`.trim();

      setSelectedCustomerId(receipt.klient_id);
      setCustomerSearchTerm(customerName);

      // Skladanie adresu: 'ulica numer_domu' lub samo ulica jesli numer NULL
      // (czesto ulica zawiera juz numer, np. 'Sloneczna 46')
      const adresParts = [
        (receipt.ulica || '').trim(),
        (receipt.numer_domu || '').trim(),
      ].filter(Boolean);
      setFormData(prev => ({
        ...prev,
        nabywca_nazwa: customerName,
        nabywca_nip: receipt.klient_nip || '',
        nabywca_adres: adresParts.join(' '),
        nabywca_miasto: receipt.miasto || '',
        nabywca_kod_pocztowy: receipt.kod_pocztowy || '',
        nabywca_telefon: receipt.telefon || '',
        nabywca_email: receipt.email || '',
        typ_faktury: 'imienna'
      }));
    }
  }, [receipt]);

  // Filtruj klientow na podstawie wyszukiwania
  const filteredCustomers = (Array.isArray(customers) ? customers : []).filter(customer => {
    if (!customerSearchTerm) return false;

    const searchLower = customerSearchTerm.toLowerCase();
    const customerName = customer.name || `${customer.imie || ''} ${customer.nazwisko || ''}`.trim();

    return customerName.toLowerCase().includes(searchLower) ||
           (customer.nip && customer.nip.includes(searchLower)) ||
           (customer.phone && customer.phone.includes(searchLower)) ||
           (customer.telefon && customer.telefon.includes(searchLower));
  });

  const handleCustomerSelect = (customer) => {
    const customerName = customer.name || `${customer.imie || ''} ${customer.nazwisko || ''}`.trim();

    setCustomerSearchTerm(customerName);
    setSelectedCustomerId(customer.id);
    setShowCustomerDropdown(false);

    setFormData(prev => ({
      ...prev,
      nabywca_nazwa: customerName,
      nabywca_nip: customer.nip || '',
      nabywca_adres: customer.address || `${customer.ulica || ''} ${customer.numer_domu || ''}`.trim(),
      nabywca_miasto: customer.miasto || customer.city || '',
      nabywca_kod_pocztowy: customer.kod_pocztowy || customer.postal_code || '',
      nabywca_telefon: customer.phone || customer.telefon || '',
      nabywca_email: customer.email || ''
    }));
  };

  const handleCustomerSearchChange = (e) => {
    const value = e.target.value;
    setCustomerSearchTerm(value);
    setShowCustomerDropdown(value.length > 0);

    if (value.length === 0) {
      setSelectedCustomerId('');
      setFormData(prev => ({
        ...prev,
        nabywca_nazwa: '',
        nabywca_nip: '',
        nabywca_adres: '',
        nabywca_miasto: '',
        nabywca_kod_pocztowy: '',
        nabywca_telefon: '',
        nabywca_email: ''
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.nabywca_nazwa.trim()) {
      toast.error('Nazwa nabywcy jest wymagana');
      return;
    }

    onSubmit(receipt.id, formData);
  };

  const clearCustomer = () => {
    setSelectedCustomerId('');
    setCustomerSearchTerm('');
    setFormData(prev => ({
      ...prev,
      nabywca_nazwa: '',
      nabywca_nip: '',
      nabywca_adres: '',
      nabywca_miasto: '',
      nabywca_kod_pocztowy: '',
      nabywca_telefon: '',
      nabywca_email: ''
    }));
  };

  const inputStyle = {
    width: '100%',
    padding: '6px 10px',
    border: '1px solid var(--border)',
    borderRadius: '6px',
    fontSize: '12px',
    backgroundColor: 'var(--card-bg)',
    color: 'var(--text)',
    height: '30px'
  };

  const labelStyle = {
    display: 'block',
    fontSize: '11px',
    color: 'var(--text-muted)',
    marginBottom: '2px'
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1050,
      padding: '0.5rem'
    }}>
      <div style={{
        background: "var(--card-bg)",
        borderRadius: '6px',
        width: '600px',
        maxWidth: '95vw',
        maxHeight: '90vh',
        overflow: 'auto',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
      }}>
        {/* Header */}
        <div style={{
          padding: '0.75rem 1rem',
          backgroundColor: 'var(--card-bg)', border: '1px solid var(--border)', color: 'var(--text)' ,
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          position: 'sticky',
          top: 0,
          zIndex: 10
        }}>
          <div style={{
            width: '2rem',
            height: '2rem',
            background: 'var(--bg-secondary)',
            borderRadius: '5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1rem'
          }}>
            📧
          </div>
          <div style={{ flex: 1 }}>
            <h5 style={{ margin: 0, fontWeight: '600', fontSize: '13px' }}>
              Utworz fakture z paragonu
            </h5>
            <p style={{ margin: 0, fontSize: '10px', opacity: 0.9 }}>
              {receipt.numer_transakcji} {'•'} {parseFloat(receipt.suma_do_zaplaty || receipt.suma_brutto).toFixed(2)} zl
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              
              fontSize: '1.25rem',
              color: 'var(--text)' ,
              cursor: 'pointer',
              padding: '0.25rem',
              lineHeight: 1
            }}
          >
            {'✕'}
          </button>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: '1rem' }}>
          {/* Szczegoly paragonu - kompaktowe */}
          <div style={{
            marginBottom: '0.75rem',
            padding: '0.75rem',
            background: 'var(--bg)',
            borderRadius: '5px',
            border: '1px solid var(--border)'
          }}>
            <h6 style={{ margin: '0 0 0.5rem 0', fontWeight: '600', color: 'var(--text-secondary)', fontSize: '11px' }}>
              📋 Szczegoly paragonu
            </h6>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0.5rem' }}>
              <div style={{ padding: '0.4rem', background: 'var(--info-light)', borderRadius: '4px', textAlign: 'center' }}>
                <div style={{ fontSize: '9px', color: 'var(--text-muted)' }}>Data</div>
                <div style={{ fontSize: '11px', fontWeight: '600', color: 'var(--info)' }}>
                  {receipt.data_transakcji}
                </div>
              </div>
              <div style={{ padding: '0.4rem', background: 'var(--success-light)', borderRadius: '4px', textAlign: 'center' }}>
                <div style={{ fontSize: '9px', color: 'var(--text-muted)' }}>Do zaplaty</div>
                <div style={{ fontSize: '11px', fontWeight: '600', color: 'var(--success)' }}>
                  {parseFloat(receipt.suma_do_zaplaty || receipt.suma_brutto).toFixed(2)} zl
                </div>
              </div>
              <div style={{ padding: '0.4rem', background: 'var(--warning-light)', borderRadius: '4px', textAlign: 'center' }}>
                <div style={{ fontSize: '9px', color: 'var(--text-muted)' }}>VAT</div>
                <div style={{ fontSize: '11px', fontWeight: '600', color: 'var(--warning)' }}>
                  {parseFloat(receipt.suma_vat).toFixed(2)} zl
                </div>
              </div>
            </div>

            {/* Pozycje paragonu - zwiniete */}
            {receipt.pozycje && receipt.pozycje.length > 0 && (
              <details style={{ marginTop: '0.5rem' }}>
                <summary style={{ fontSize: '10px', color: 'var(--text-muted)', cursor: 'pointer' }}>
                  Zobacz pozycje ({receipt.pozycje.length})
                </summary>
                <div style={{ marginTop: '0.5rem', maxHeight: '120px', overflowY: 'auto' }}>
                  <table style={{ width: '100%', fontSize: '10px', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: 'var(--border)' }}>
                        <th style={{ padding: '4px', textAlign: 'left' }}>Produkt</th>
                        <th style={{ padding: '4px', textAlign: 'center', width: '50px' }}>Ilosc</th>
                        <th style={{ padding: '4px', textAlign: 'right', width: '70px' }}>Wartosc</th>
                      </tr>
                    </thead>
                    <tbody>
                      {receipt.pozycje.map((item, index) => (
                        <tr key={index} style={{ borderBottom: '1px solid var(--border)' }}>
                          <td style={{ padding: '4px' }}>{item.nazwa_produktu}</td>
                          <td style={{ padding: '4px', textAlign: 'center' }}>{item.ilosc}</td>
                          <td style={{ padding: '4px', textAlign: 'right' }}>{parseFloat(item.wartosc_brutto).toFixed(2)} zl</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </details>
            )}
          </div>

          {/* Wybor klienta */}
          <div style={{
            marginBottom: '0.75rem',
            padding: '0.75rem',
            background: 'var(--bg)',
            borderRadius: '5px',
            border: '1px solid var(--border)'
          }}>
            <h6 style={{ margin: '0 0 0.5rem 0', fontWeight: '600', color: 'var(--text-secondary)', fontSize: '11px' }}>
              📇 Wybor klienta
            </h6>
            <div style={{ position: 'relative', marginBottom: '0.5rem' }}>
              <input
                type="text"
                placeholder={'🔍 Szukaj klienta (nazwa, NIP, telefon)...'}
                value={customerSearchTerm}
                onChange={handleCustomerSearchChange}
                onFocus={() => customerSearchTerm && setShowCustomerDropdown(true)}
                onBlur={() => setTimeout(() => setShowCustomerDropdown(false), 200)}
                style={inputStyle}
              />

              {showCustomerDropdown && filteredCustomers.length > 0 && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  background: "var(--card-bg)",
                  border: '1px solid var(--border)',
                  borderRadius: '0 0 4px 4px',
                  maxHeight: '150px',
                  overflowY: 'auto',
                  zIndex: 100,
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                }}>
                  {filteredCustomers.slice(0, 8).map(customer => {
                    const customerName = customer.name || `${customer.imie || ''} ${customer.nazwisko || ''}`.trim();
                    return (
                      <div
                        key={customer.id}
                        onClick={() => handleCustomerSelect(customer)}
                        style={{
                          padding: '6px 8px',
                          cursor: 'pointer',
                          borderBottom: '1px solid var(--bg)',
                          fontSize: '11px',
                          display: 'flex',
                          justifyContent: 'space-between'
                        }}
                        onMouseEnter={(e) => e.target.style.background = 'var(--bg)'}
                        onMouseLeave={(e) => e.target.style.background = '#fff'}
                      >
                        <span>
                          <strong>{customerName}</strong>
                          {customer.nip && <span style={{ color: 'var(--text-muted)', marginLeft: '4px' }}>(NIP: {customer.nip})</span>}
                        </span>
                        <span style={{ color: 'var(--text-muted)' }}>
                          {customer.typ_klienta === 'firma' ? '🏢' : '👤'}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {selectedCustomerId && (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '4px 8px',
                background: 'var(--success-light)',
                borderRadius: '3px',
                fontSize: '10px',
                color: 'var(--success)'
              }}>
                {'✅'} Wybrano klienta z kartoteki
                <button
                  type="button"
                  onClick={clearCustomer}
                  style={{
                    background: 'none',
                    
                    color: 'var(--success)',
                    cursor: 'pointer',
                    fontSize: '11px',
                    textDecoration: 'underline'
                  }}
                >
                  Wyczysc
                </button>
              </div>
            )}
          </div>

          {/* Dane nabywcy */}
          <div style={{
            marginBottom: '0.75rem',
            padding: '0.75rem',
            background: 'var(--bg)',
            borderRadius: '5px',
            border: '1px solid var(--border)'
          }}>
            <h6 style={{ margin: '0 0 0.5rem 0', fontWeight: '600', color: 'var(--text-secondary)', fontSize: '11px' }}>
              👤 Dane nabywcy
            </h6>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
              <div>
                <label style={labelStyle}>Nazwa / Firma *</label>
                <input
                  type="text"
                  value={formData.nabywca_nazwa}
                  onChange={(e) => setFormData(prev => ({ ...prev, nabywca_nazwa: e.target.value }))}
                  required
                  style={inputStyle}
                />
              </div>

              <div>
                <label style={labelStyle}>NIP</label>
                <input
                  type="text"
                  value={formData.nabywca_nip}
                  onChange={(e) => setFormData(prev => ({ ...prev, nabywca_nip: e.target.value }))}
                  style={inputStyle}
                />
              </div>

              <div>
                <label style={labelStyle}>Adres</label>
                <input
                  type="text"
                  value={formData.nabywca_adres}
                  onChange={(e) => setFormData(prev => ({ ...prev, nabywca_adres: e.target.value }))}
                  style={inputStyle}
                />
              </div>

              <div>
                <label style={labelStyle}>Miasto</label>
                <input
                  type="text"
                  value={formData.nabywca_miasto}
                  onChange={(e) => setFormData(prev => ({ ...prev, nabywca_miasto: e.target.value }))}
                  style={inputStyle}
                />
              </div>

              <div>
                <label style={labelStyle}>Kod pocztowy</label>
                <input
                  type="text"
                  value={formData.nabywca_kod_pocztowy}
                  onChange={(e) => setFormData(prev => ({ ...prev, nabywca_kod_pocztowy: e.target.value }))}
                  style={inputStyle}
                />
              </div>

              <div>
                <label style={labelStyle}>Email</label>
                <input
                  type="email"
                  value={formData.nabywca_email}
                  onChange={(e) => setFormData(prev => ({ ...prev, nabywca_email: e.target.value }))}
                  style={inputStyle}
                />
              </div>
            </div>
          </div>

          {/* Przyciski */}
          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: '6px 12px',
                background: 'var(--bg)',
                color: 'var(--text-muted)',
                border: '1px solid var(--border)',
                fontWeight: '500',
                fontSize: '12px',
                cursor: 'pointer'
              }}
            >
              Anuluj
            </button>
            <button
              type="submit"
              style={{
                padding: '6px 12px',
                border: '1px solid var(--info)',
                color: 'var(--info)',
                fontWeight: '600',
                fontSize: '12px'
              }}
            >
              📧 Utworz fakture
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SalesInvoiceForm;
